import React, { useEffect, useState } from 'react';
import api from '../services/api';

interface SalesmanStats {
  id: string;
  name: string;
  doorsKnocked: number;
  sold: number;
  appointments: number;
  callbacks: number;
  conversionRate: number;
  earnedCommission: number;
  pendingCommission: number;
  score: number;
  rank: number;
}

const MEDALS = ['🥇', '🥈', '🥉'];

export default function LeaderboardPage() {
  const [data, setData] = useState<SalesmanStats[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/leaderboard').then(r => setData(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, color: '#fff', marginBottom: 8 }}>🏆 Leaderboard</h1>
      <p style={{ color: '#8FA8C0', marginBottom: 32 }}>💰 Sold = 500pts · 📅 Appt = 2pts · 👍 Lead = 2pts · 📞 CB = 2pts · ↩️ Go Back = 2pts · 🚪 Door = 1pt · Conv &gt;20% = +15pts</p>

      {/* Top 3 Podium */}
      {data.length >= 3 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 16, marginBottom: 40, height: 160 }}>
          {[1, 0, 2].map(i => {
            const s = data[i];
            const heights = [120, 100, 80]; // 1st=tallest, 2nd=medium, 3rd=shortest
            const colors = ['#C0C0C0', '#FFD700', '#CD7F32'];
            return (
              <div key={s.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 120 }}>
                <div style={{ fontSize: 32, marginBottom: 4 }}>{MEDALS[i]}</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#fff', marginBottom: 4 }}>{s.name.split(' ')[0]}</div>
                <div style={{
                  width: '100%', height: heights[i],
                  background: colors[i], borderRadius: '8px 8px 0 0',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <span style={{ fontSize: 20, fontWeight: 800, color: '#111' }}>{s.score}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Full Rankings Table */}
      <div style={{ background: '#1A2B3C', borderRadius: 16, border: '1px solid #2D4259', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #2D4259' }}>
              {['Rank', 'Salesman', 'Score', '🚪 Knocked', '💰 Sold', '📅 Appts', '📞 CB', '📈 Conv%', '$ Earned'].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#4A6580', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((s, i) => (
              <tr key={s.id} style={{ borderBottom: '1px solid #2D4259', background: i < 3 ? '#1E3040' : 'transparent' }}>
                <td style={{ padding: '14px 16px', fontSize: 20 }}>{i < 3 ? MEDALS[i] : `#${s.rank}`}</td>
                <td style={{ padding: '14px 16px', fontWeight: 700, color: '#fff' }}>{s.name}</td>
                <td style={{ padding: '14px 16px', fontWeight: 800, color: i === 0 ? '#FFD700' : '#4A7EB5', fontSize: 18 }}>{s.score}</td>
                <td style={{ padding: '14px 16px', color: '#8FA8C0' }}>{s.doorsKnocked}</td>
                <td style={{ padding: '14px 16px', color: '#10B981', fontWeight: 700 }}>{s.sold}</td>
                <td style={{ padding: '14px 16px', color: '#8FA8C0' }}>{s.appointments}</td>
                <td style={{ padding: '14px 16px', color: '#8FA8C0' }}>{s.callbacks}</td>
                <td style={{ padding: '14px 16px', color: s.conversionRate > 20 ? '#10B981' : '#8FA8C0', fontWeight: s.conversionRate > 20 ? 700 : 400 }}>{s.conversionRate}%</td>
                <td style={{ padding: '14px 16px', color: '#10B981', fontWeight: 600 }}>${s.earnedCommission.toFixed(0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data.length === 0 && !loading && (
          <div style={{ padding: 60, textAlign: 'center', color: '#4A6580' }}>No salesmen yet</div>
        )}
      </div>
    </div>
  );
}
